import urls from "./urls";
import service from "../config/service"
import "../assets/css/dialog.css"

function htmlContent () {
    return '<div class="mask-closable"></div><div class="verification-content"><div class="header"><h3>操作次数太多,请输入验证码</h3></div><div class="verification-code-img-container"><div class="verification-code-img-container_img"></div><a href="javascript:;">区分大小写,看不清?点击图片切换</a><input type="text"></div><div class="footer"><button type="button">确定</button></div></div>';
}

const verification = {
    show: (data) => {
        let dialog = document.querySelector("#sgm-common-dialog-verification-code");
        if (!dialog) {
            dialog = document.createElement('div');
            dialog.id = 'sgm-common-dialog-verification-code';
            dialog.innerHTML = htmlContent();
            let left = (document.body.offsetWidth - 300)/2;
            dialog.style.left = left + 'px';
            document.body.append(dialog); 
        }
        dialog.querySelector(".verification-code-img-container_img").innerHTML = data;
        dialog.querySelector(".verification-code-img-container_img").onclick = 
        dialog.querySelector(".verification-code-img-container a").onclick = ()=>{
            verification.swichCode();
        }
        dialog.querySelector(".footer button").onclick = ()=>{
            verification.confirmCode();
        }
    },
    hide: ()=>{
        let dialog = document.querySelector("#sgm-common-dialog-verification-code");
        if (dialog) {
            dialog.remove();
        }
    },

    swichCode(){
        // 刷新验证码
        verification.setverification("");
    },

    confirmCode(){
        let inputValue$ = document.querySelector("#sgm-common-dialog-verification-code .verification-code-img-container > input");
        if(!inputValue$.value) { return;}
        verification.setverification(inputValue$.value);
    },

    setverification(code){
        service(urls.SET_VERIFICATION, {data: {code: code}}).then((res)=>{
            verification.hide();
        });
    }
}

export default verification;